"use strict";
// This file sets up functionality and behavior for nav dropdowns without hover and the menu on mobile.

import { onWindowWidthChange } from "./helper-functions.js";

let nav = {
	items_w_children: null,
	hover_deactivated: false,

	setup: function() {
		this.main_nav = document.getElementById("main-nav");
		this.items_w_children = document.querySelectorAll("#main-nav li.menu-item-has-children");

		this.items_w_children.forEach(el => {
			el.addEventListener("click", (event) => {this.toggleNavItem(event)});
		});

		window.addEventListener("load", () => {
			this.subMenusSetup(this.items_w_children);
			onWindowWidthChange(() => {this.subMenusSetup(this.items_w_children)});
		});
	},

	toggleNavItem: function(event) {
		let classList = event.currentTarget.classList;
		let isCurrentlyHovered = event.currentTarget.parentElement.querySelector(':hover') === event.currentTarget;

		if (!this.hover_deactivated) {
			this.main_nav.classList.add("is-using-click");
			this.hover_deactivated = true;
			if (isCurrentlyHovered) {
				return;
			}
		}
	
		if ( classList.contains('is-active') ) {
			classList.remove('is-active');
		} else {
			this.items_w_children.forEach(el => {
				el.classList.remove('is-active');
			});

			classList.add('is-active')
		}
	},

	subMenusSetup: function(items_w_children) {
		items_w_children.forEach((el) => {
			let sub_menu = el.querySelector(".sub-menu");
			sub_menu.style.setProperty('--expanded-height', 'auto');
			sub_menu.style.setProperty('--expanded-width', 'auto');

			let height = sub_menu.scrollHeight + "px";
			let width = sub_menu.scrollWidth + "px";
			sub_menu.style.setProperty('--expanded-height', height);
			sub_menu.style.setProperty('--expanded-width', width);
		})
	}
}


function toggleMobileMenu() {
	this.toggle.classList.toggle("is-open");
	this.nav.classList.toggle("is-open");
}

function setupMobileMenu() {
	var mobile_menu = {
		toggle: document.querySelector("#mobile-menu-toggle"),
		nav: document.querySelector("#main-nav")
	};

	mobile_menu.toggle.addEventListener("click", toggleMobileMenu.bind(mobile_menu), false);
}


setupMobileMenu();
nav.setup();
